<template>
    <div>
        <div class="filters">
            <tl-select
              label="Entity"
             :options="['Entity1']"
             />
            <tl-select
              label="Location"
             :options="['Location1']"
             />
             <tl-select
              label="Paygroups"
             :options="['Paygroup1']"
             />
             <div>
             <button class="btn secondary btnfilter">Apply Filter</button>
             </div>
        </div>

        <div class="searchsort">
           <tl-search/>
           <div class="uploadDiv">
            <img src="@/assets/logout-copy-2.svg"/>&nbsp;
            <button class="export-button">Export</button>
          </div>
          <div class="sorttext">
            <span>Sort By: </span>
          </div>
          &nbsp; &nbsp;
          <!-- <div class="selectdiv">
              <select v-model="sort" class="dropdown">
                  <option selected="selected">Recently Joined</option>
                  <option>Admin</option>
                  <option>IT</option>
              </select>
            </div>  -->
            <tl-select
               class="sort-select"
              :options="['Recently Added','IT']"
              @change="(val)=>{sort=val}"
              :value="sort"
             />
            <div class="sorticons">
              <img src="@/assets/list_view.png"/>&nbsp;
              <span class="vertical-line"></span>
              <img src="@/assets/list_view.png"/>&nbsp;
              <span class="vertical-line"></span>
              <img src="@/assets/list_view.png"/>
            </div>
        </div> 
        <div>
          <data-table
            :columns="columnNames"
            :tableData="employeeData"
            :checkbox="false"
            :search="search"
            :showinrow="false"
           > 
            <template v-slot:rowcontent="slotprops">
              <img class="sm-img" v-if="slotprops.value.column.key=='image'" 
                :src="slotprops.value.record[slotprops.value.column.key]"/>
                <div v-else-if="slotprops.value.column.key=='assignedperks'">
                  <span v-for="(item,index) in slotprops.value.record[slotprops.value.column.key]" :key="item">
                     {{item}}
                     <span v-if="index!=slotprops.value.record[slotprops.value.column.key].length-1">,</span>
                  </span>
                </div>
                <div v-else>
                  <span>{{slotprops.value.record[slotprops.value.column.key]}}</span>
                </div>
            </template>
        </data-table>
        </div>
        <bottom-action-container >
          <template slot="end">
                <btn-grp>
                  <btn text="Back" type="secondary" @click="goBack"/>
                </btn-grp>
            </template>
        </bottom-action-container>
    </div>
</template>

<script>
export default {
  data(){
    return{
      sort:'',
      columnNames: [
        {
          label: "",
          key: "image"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Assigned Perks",
          key: "assignedperks"
        }],
        employeeData: [
        {
          image: require('@/assets/Girl.png'),
          code: "RC1234",
          name: "Roxie Schmidt",
          department: "IT",
          assignedperks:['Company Accommodation Perk', 'Car Perk', 'Other Perk']
        },
        {
          image: require('@/assets/Girl.png'),
          code: "RC1234",
          name: "Lucas Schmidt",
          department: "IT",
          assignedperks:['Car Perk', 'Loan Perk']
        }], 
    }
  },
  methods:{
    goBack(){this.$router.push(`/dashboard/${this.$route.params.entity_index}/organisation/utilities`)}
  }
}
</script>

<style lang="scss" scoped>
.btnfilter{
  margin-top: 20px;
  padding: 0px;
  min-height: 35px;
}
.searchsort{
  display: flex;
  padding-top: 20px;
  .selectdiv{
    width: 15%;
  }
}
.uploadDiv {
   width: 10%;
   margin-left: auto;  
   text-align: center;
   justify-content: end;
   padding: 10px 0px 0px 0px;
//   button{
//     cursor: pointer;
//     width: 60%;
//     height: 70%;
//     border-radius: 4px;
//     color:#5d409f;
//     border: 1px solid #5d409f;
//     }
   img{
     height: 45%;
     margin-bottom: -10px;
   } 
}
.sorttext{
  // width: 10%;
  // text-align: center;
  line-height: 45px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons{
  width: 13%;
  padding: 8px 0px 5px 10px;
  span{
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.sort-select{
  width:205px;
}
.footer-width {
    width: 88%;
  }
</style>
